import AffiliationSetupContext from './AffiliationSetupContext'
import affiliationSetupHooks from './hooks'

export { affiliationSetupHooks }
export default AffiliationSetupContext